// extracted by mini-css-extract-plugin
module.exports = {"kitD":"kitD_kitD__UxGhH"};